export const ADD_INTEGRATION_REQUEST = "ADD_INTEGRATION_REQUEST";
export const ADD_INTEGRATION_RESULT = "ADD_INTEGRATION_RESULT";
export const ADD_INTEGRATION_OPEN_MODAL = "ADD_INTEGRATION_OPEN_MODAL";
export const ADD_INTEGRATION_CLOSE_MODAL = "ADD_INTEGRATION_CLOSE_MODAL";
export const ADD_INTEGRATION_GET_INTEGRATIONS_REQUEST = "ADD_INTEGRATION_GET_INTEGRATIONS_REQUEST";
export const ADD_INTEGRATION_GET_INTEGRATIONS_RESULT = "ADD_INTEGRATION_GET_INTEGRATIONS_RESULT";

export const ADD_INTEGRATION_CEREBRUMX_REQUEST = "ADD_INTEGRATION_CEREBRUMX_REQUEST";
export const ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_REQUEST = "ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_REQUEST";
export const ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_RESULT = "ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_RESULT";


